export enum PopupDisplayMode {
    XLARGE = 'DISPLAY_MODE_XLARGE',
    LARGE = 'DISPLAY_MODE_LARGE',
    SMALL = 'DISPLAY_MODE_SMALL'
}
